import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("span", {
    class: _normalizeClass('mdi mdi-' + _ctx.icon + ' ' + _ctx.size + ' ' + _ctx.color)
  }, null, 2);
}